(function () {
  'use strict';

  var intentRoutes = {
    'tomato': '/collections/tomato-seeds',
    'tomatoes': '/collections/tomato-seeds',
    'tomato seeds': '/collections/tomato-seeds',
    'pepper': '/collections/pepper-seeds',
    'peppers': '/collections/pepper-seeds',
    'pepper seeds': '/collections/pepper-seeds',
    'fruit tree seed': '/collections/fruit-tree-seeds',
    'fruit tree seeds': '/collections/fruit-tree-seeds',
    'tree seed': '/collections/tree-seeds',
    'tree seeds': '/collections/tree-seeds',
    'berry seed': '/collections/berry-bush-seeds',
    'berry seeds': '/collections/berry-bush-seeds',
    'native seed': '/collections/native-seeds',
    'native seeds': '/collections/native-seeds',
    'wildflower': '/collections/native-seeds',
    'wildflowers': '/collections/native-seeds',
    'seed catalog': '/collections/all-seeds',
    'all seeds': '/collections/all-seeds'
  };

  function providerQuery(value) {
    return String(value || '')
      .replace(/\btitle:/gi, '')
      .replace(/"/g, '')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function plainQuery(value) {
    return providerQuery(value).toLowerCase();
  }

  function routeFor(value) {
    return intentRoutes[plainQuery(value)] || '';
  }

  function scopedQuery(value) {
    return providerQuery(value);
  }

  function rankVisibleResults() {
    var list = document.querySelector('.template-search #product-grid ul.product-grid');
    if (!list) return;
    var params = new URLSearchParams(window.location.search);
    // Respect a shopper's price/date sort. Only refine the current relevance page.
    if (params.get('sort_by') && params.get('sort_by') !== 'relevance') return;
    var query = plainQuery(params.get('q'));
    if (!query || query.length < 2) return;
    if (list.getAttribute('data-osn-ranked-for') === query) return;
    var terms = query.match(/[a-z0-9]+/g) || [];
    if (!terms.length) return;
    var rows = Array.prototype.slice.call(list.children);
    rows.sort(function (left, right) {
      var leftProduct = left.hasAttribute('data-osn-search-product-title');
      var rightProduct = right.hasAttribute('data-osn-search-product-title');
      if (leftProduct !== rightProduct) return leftProduct ? -1 : 1;
      if (!leftProduct) return 0;
      var leftTitle = left.getAttribute('data-osn-search-product-title') || '';
      var rightTitle = right.getAttribute('data-osn-search-product-title') || '';
      var leftScore = terms.reduce(function (score, term) {
        return score + (leftTitle.indexOf(term) !== -1 ? 1 : 0);
      }, 0);
      var rightScore = terms.reduce(function (score, term) {
        return score + (rightTitle.indexOf(term) !== -1 ? 1 : 0);
      }, 0);
      return rightScore - leftScore;
    });
    list.setAttribute('data-osn-ranked-for', query);
    rows.forEach(function (row) { list.appendChild(row); });
  }

  function emit(name, payload) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-search-intent]');
    if (!link) return;
    emit('search_intent_route', {
      destination_collection: link.getAttribute('data-search-intent') || '',
      source_surface: 'storefront_search',
      osn_test_traffic: new URLSearchParams(window.location.search).has('preview_theme_id')
        ? 'release_verification'
        : 'none'
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[role="search"]');
    if (!form) return;
    if (form.hasAttribute('data-s1-search-form')) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var route = routeFor(input.value);
    if (route) {
      event.preventDefault();
      emit('search_intent_route', {
        destination_collection: route.replace('/collections/', ''),
        source_surface: 'storefront_search_submit',
        search_intent_class: 'broad_category',
        osn_test_traffic: new URLSearchParams(window.location.search).has('preview_theme_id')
          ? 'release_verification'
          : 'none'
      });
      var locale = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      window.location.assign(locale.replace(/\/$/, '') + route);
      return;
    }
    input.value = scopedQuery(input.value);
    // Available alternatives must not displace an exact sold out match across
    // pagination. Collection sorting remains independent from search relevance.
    var availability = form.querySelector('input[name="options[unavailable_products]"]');
    if (!availability) {
      availability = document.createElement('input');
      availability.type = 'hidden';
      availability.name = 'options[unavailable_products]';
      form.appendChild(availability);
    }
    availability.value = 'show';
  }, true);

  document.addEventListener('DOMContentLoaded', rankVisibleResults);
  document.addEventListener('shopify:section:load', rankVisibleResults);
  new MutationObserver(function (mutations) {
    if (mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        return node.nodeType === 1 && (
          node.id === 'ProductGridContainer' ||
          node.closest?.('#ProductGridContainer') ||
          node.querySelector?.('#ProductGridContainer')
        );
      });
    })) rankVisibleResults();
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.OSNSearch = { scopedQuery: scopedQuery, routeFor: routeFor, rankVisibleResults: rankVisibleResults };
})();
